// Country-suggestion bar. The server (/geo-suggest) decides whether to show it;
// we fetch once per session+language, cache the result so later page views skip
// the request, and inject it client-side. Loaded only for anonymous users.
(function (window, document) {
    function cacheKey() {
        return 'geoSuggest:' + (document.documentElement.lang || 'en');
    }

    function inject(html) {
        if (!html) return;
        var holder = document.createElement('div');
        holder.innerHTML = html.trim();
        var bar = holder.firstElementChild;
        if (!bar) return;
        var link = bar.querySelector('a[href]');
        // a cached banner can outlive a move onto its own storefront — don't show it there
        if (link && location.pathname.replace(/\/$/, '') === link.getAttribute('href')) return;
        document.body.appendChild(bar);
        var setHeight = function () {
            document.documentElement.style.setProperty('--geo-h', bar.offsetHeight + 'px');
        };
        setHeight();
        document.body.classList.add('geo-on');
        requestAnimationFrame(function () { bar.classList.add('geo-in'); });
        window.addEventListener('resize', setHeight);
        bar.querySelector('[data-geo-dismiss]').addEventListener('click', function () {
            document.cookie = 'geo_hint=off; path=/; max-age=31536000; samesite=lax';
            try { sessionStorage.removeItem(cacheKey()); } catch (e) {}
            bar.remove();
            document.documentElement.style.setProperty('--geo-h', '0px');
            document.body.classList.remove('geo-on');
        });
    }

    function run() {
        if (/(?:^|;\s*)geo_hint=off/.test(document.cookie)) return;
        var cached = null;
        try { cached = sessionStorage.getItem(cacheKey()); } catch (e) {}
        if (cached !== null) { inject(cached); return; }
        var geo = location.search.match(/[?&]geo=([A-Za-z]{2})/);
        fetch('/geo-suggest' + (geo ? '?geo=' + geo[1] : ''), {headers: {'X-Requested-With': 'fetch'}})
            .then(function (r) { return r.status === 200 ? r.text() : ''; })
            .then(function (html) {
                try { sessionStorage.setItem(cacheKey(), html); } catch (e) {}
                inject(html);
            }).catch(function () {});
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', run);
    } else {
        run();
    }
})(window, document);
